import { render, staticRenderFns } from "./VersionRemark.vue?vue&type=template&id=2cc3d6c4&scoped=true"
import script from "./VersionRemark.vue?vue&type=script&lang=js"
export * from "./VersionRemark.vue?vue&type=script&lang=js"
import style0 from "./VersionRemark.vue?vue&type=style&index=0&id=2cc3d6c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3d6c4",
  null
  
)

export default component.exports